"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.InitialRequestPositionDTO = void 0;
const omit_type_helper_1 = require("../../extern-libs/mapped-types/omit-type.helper");
const BaseRequestPositionDTO_1 = require("./BaseRequestPositionDTO");
class InitialRequestPositionDTO extends (0, omit_type_helper_1.OmitType)(BaseRequestPositionDTO_1.BaseRequestPositionDTO, ['resourceIds', 'requiredPositionIds']) {
}
exports.InitialRequestPositionDTO = InitialRequestPositionDTO;
